import { Piece } from "../../../Piece";
import { PieceType } from "../../../types";
import {
  ISideEffectHandler,
  SideEffectHandlerParams,
} from "./SideEffectHandler";

export class ShadowEffectHandler implements ISideEffectHandler {
  handleSideEffect(params: SideEffectHandlerParams): void {
    // Check if the inflicting piece is zombified - this creates "zombie ink" shadows
    const isZombified = params.inflictingPiece.zombifiedStatus?.isZombified;

    // for each side effect place a new Octopus piece on the board with Shadowed property
    params.sideEffects.forEach((sideEffect) => {
      var shadowOctopus = new Piece(
        PieceType.Octopus,
        params.inflictingPiece.isLight
      );
      shadowOctopus.isShadow = true;

      // If zombie ink, mark the shadow so it persists for the original owner to deal with
      if (isZombified) {
        shadowOctopus.isZombieInkShadow = true;
        // Target color is the original owner (the piece's actual color)
        // They must find their real octopus among the shadows
        shadowOctopus.zombieInkTargetColor = params.inflictingPiece.isLight;
      } else {
      }

      params.movementManager
        .getGameStateManager()
        .placePiece(shadowOctopus, sideEffect.position);
    });
  }
}
